module.exports = __webpack_public_path__ + "img/ideas.ec6f78ba.png";